import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';
import FormControl from 'react-bootstrap/lib/FormControl';
import Button from 'react-bootstrap/lib/Button';

import { createSubscription } from 'actions';

import './subscribe-form-section.css';

export class SubscribeForm extends Component {
  constructor(...args) {
    super(...args);
    this.submitHandler = this.onFormSubmit.bind(this);
    this.fieldChangeHandler = this.onFieldChange.bind(this);
    this.state = {
      email: '',
      fetching: false,
      success: false,
      error: null
    };
  }

  onFormSubmit(event) {
    event.preventDefault();

    if (this.state.success || !this.state.email) {
      return;
    }

    this.setState({
      fetching: true,
      success: false,
      error: null
    });

    this.props.createSubscription({
      email: this.state.email
    }).then(action => {
      if (action.error) {
        this.setState({
          fetching: false,
          success: false,
          error: action.error
        });

        if (typeof this.props.onFail === 'function') {
          this.props.onFail(action.error);
        }

      } else {
        this.setState({
          fetching: false,
          success: true
        });

        if (typeof this.props.onSuccess === 'function') {
          this.props.onSuccess();
        }
      }
    });
  }

  onFieldChange(event) {
    this.setState({
      email: event.target.value
    });
  }

  render() {
    const { t } = this.props;

    return (
      <form className="subscribe-form" onSubmit={this.submitHandler}>
        <FormControl
          type="text"
          value={this.state.email}
          placeholder={t(this.props.inputPlaceholder || 'Your email address')}
          onChange={this.fieldChangeHandler} />

        <Button type="submit" bsStyle="primary">
          {t(this.props.buttonText || 'Subscribe')}
        </Button>
      </form>
    );
  }
}

SubscribeForm.propTypes = {
  t: PropTypes.func.isRequired,
  createSubscription: PropTypes.func.isRequired,
  inputPlaceholder: PropTypes.string,
  buttonText: PropTypes.string,
  onSuccess: PropTypes.func,
  onFail: PropTypes.func
};

export const SubscribeFormI18n = connect(null, {
  createSubscription
})(
  translate(['translation'])(SubscribeForm)
);

class SubscribeFormSection extends Component {
  constructor(...args) {
    super(...args);
    this.onSuccess = () => this.setState({ subscribed: true });
    this.onFail = (error) => this.setState({ error });
    this.state = {
      subscribed: false,
      error: null
    };
  }

  render() {
    const { t } = this.props;
    const { subscribed, error } = this.state;

    return (
      <div className="subscribe-section">
        {(!subscribed) &&
          <Grid>
            <h2>{t('Subscribe to our newsletter')}</h2>
            <p>{t('Promotions, new destinations and special offers from BikesBooking.com and partners!')}</p>

            <SubscribeFormI18n
              inputPlaceholder="Your email address"
              buttonText="Join!"
              onSuccess={this.onSuccess}
              onFail={this.onFail}
            />

            <p>
              {(!error) &&
                <small className="subscribe-msg">
                  {t('We promise not to bother you and send only a good stuff!')}
                </small>
              }

              {(error && error.email && error.email.length) &&
                <small className="error-msg">
                  {error.email[0]}
                </small>
              }
            </p>
          </Grid>
        }

        {(subscribed) &&
          <Grid>
            <p className="success-msg">
              {t('You have successfully subscribed to the newsletter ')}
            </p>
          </Grid>
        }
      </div>
    );
  }
}

export default translate(['translation'])(SubscribeFormSection);



// WEBPACK FOOTER //
// ./src/widgets/SubscribeFormSection/index.js